import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css/normalize.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('app'));
